import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { TrainingQuery as TrainingQueryType, TrainingQueryVariables } from "./__generated__/TrainingQuery";

const TrainingQuery = loader("./TrainingQuery.gql");

type TrainingQueryProviderType = (props: {
  children: (data: TrainingQueryType) => ReactNode;
  variables: TrainingQueryVariables;
}) => ReactElement;

export const TrainingQueryProvider: TrainingQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<TrainingQueryType, TrainingQueryVariables>(TrainingQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
